import { Formik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    Button,
    Form,
  FormGroup,
  Modal,
  ModalBody,
} from "reactstrap";
import SvgImage from "../../../Icons/Icons";
import "./index.css";
import { toast } from "react-toastify";
import { addServiceItems, getServiceItems } from "../../../../services/Store/Actions/fleetActions";

function AddItemTypeModal(props) {
  const dispatch = useDispatch();

  const { toggle, modal, setModal, data } = props;
  console.log("AddItemTypeModalAddItemTypeModal",data);
  const closeBtn = (
    <button
      className="close"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundColor: "#FFF",
        borderColor: "#2E7C7B",
        display: "flex",
        justifyContent: "space-evenly",
      }}
      onClick={toggle}
      type="button"
    >
      <div className="x">X</div>
    </button>
  );

  const handleClose = () => {
    setModal(!modal);
  };
  const documentId = "addItemTypeModal"
  const notify =  (msg, isError = false) => {
    console.log("ajshgvdkba");
    if(isError){
        toast.error(msg || "failed", {
            toastId: documentId,
        })
    }else{
        toast.success(msg || "success", {
            toastId: documentId,
        })
    }
   
}
  return (
    <div >
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className="custom-modal"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          style={{ marginTop: "25px" }}
        >
         <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <div
                className="closeBtnWithBackgroundForTrip"
                onClick={handleClose}
              >
                <SvgImage
                  classname="close-btn-text"
                  style={{ width: "10%", height: "10%" }}
                  name="crossBtnWIthBackground"
                  width="20%"
                  height="20%"
                />
              </div>
              <div
                className="PGCollectiontText col-3 "
                style={{ marginLeft: "50px" }}
              >
                  <text>Add {data?.key} Items </text>
                {/* <text>Create LR</text> */}
              </div>
              <hr
                style={{ marginLeft: "25px", border: "2px solid #2E7C7B" }}
              ></hr>
            </div>
            <Formik
                    // isValid='true'
                    enableReinitialize
                    initialValues={{

                    }}
                    onSubmit={(values) => {
                        console.log('rererere111',values)

                        let objVal = {
                            catagory: data?.key?data?.key:null,
                            name: values?.ItemName
                        };
                        dispatch(
                          addServiceItems(objVal, (res) => {
                            if (res?.status == 200) {
                                console.log('rererere',res)
                                dispatch(getServiceItems({}, (res)=> {
                                    console.log("getServiceItemsgetServiceItems", res);
                                }));
                                handleClose();
                                notify("item added successFully");
                            } else {
                                handleClose();
                                notify("item add failed", true);
                            }
                        })
                        );
                    }}
                    >
                    {({
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        resetForm,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => (
                        <Form
                        onSubmit={handleSubmit}
                        style={{ padding: "0 50px 0 50px" }}
                        >
                        <div className="">
                        <FormGroup>
                            <label for="ItemName" className="heading3 semiBold">
                                Item Title
                            </label>
                            <div className="custNamepadd3">
                                <input
                                type="text"
                                id="ItemName"
                                className={`inputBoxCust1 ${
                                    touched.ItemName && errors.ItemName ? "is-invalid" : ""
                                }`}
                                name="ItemName"
                                value={values.ItemName}
                                onChange={(event) => {
                                    setFieldValue("ItemName", event.target.value, true);
                                }}
                               
                                touched={touched.ItemName}
                                errors={errors.ItemName}
                                placeholder="Enter Item Title"
                                autocomplete="off"
                                />
                            </div>
                        </FormGroup>
                        
                    <FormGroup
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="submit"
                        style={{ width: "100%" }}
                        className="generateOtp text3 Medium btn btn-secondary"
                      >
                        Submit
                      </Button>
                    </FormGroup>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default AddItemTypeModal;
